var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9163 9.45831V7.37498L10.4997 0.083313L0.0830078 7.37498V9.45831H2.16634V18.8333H0.0830078V20.9166H20.9163V18.8333H18.833V9.45831H20.9163ZM14.6663 16.75H12.583V12.5833L10.4997 15.7083L8.41634 12.5833V16.75H6.33301V9.45831H8.41634L10.4997 12.5833L12.583 9.45831H14.6663V16.75Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCulture);
export default __webpack_public_path__ + "static/media/icon_culture.07437ed283cf9b86ca46b4889ce3d9c0.svg";
export { ForwardRef as ReactComponent };